export default "__VITE_ASSET__DMR83me2__"